module.exports = __webpack_public_path__ + "img/server-maintenance-icon.2d86a824.png";